export enum VideoProvider {
  Google = 'google',
  Zoom = 'zoom',
  Teams = 'teams',
  Jitsi = 'jitsi',
}

// This enum is introduced to handle migration from Google Hangouts to Google Meet.
// We need to support both types with custom behaviour.
export enum SpecificVideoProvider {
  GoogleMeet = 'meet',
  GoogleHangouts = 'hangouts',
}

export enum InterviewKind {
  Video = 'video',
  Call = 'call',
  Onsite = 'onsite',
  Meeting = 'meeting',
}

export enum ResponseStatus {
  Accepted = 'accepted',
  Declined = 'declined',
  NeedsAction = 'needs_action',
  Tentative = 'tentative',
}
